import { styled } from "styled-components";

export const StyledForm = styled.form`
	display: flex;
	flex-direction: column;
	width: 100%;

	label {
		color: #555555;
		font-weight: 700;
		font-size: 16px;
		margin-bottom: 10px;
		margin-top: 20px;
	}

	input {
		background: #ffffff;
		border: 1px solid #999999;
		border-radius: 30px;
		width: 100%;
		padding: 10px 20px;
		cursor: #006770;

		&::placeholder {
			color: #999999;
			font-size: 15px;
		}

		&:focus,
		&:hover {
			outline: none;
			border-color: #006770;
			background-color: #fff;
			color: #006770;
		}
	}

	.input_group {
		display: flex;
		align-items: center;
		position: relative;

		.input_icon {
			position: absolute;
			right: 22px;
			font-size: 20px;
			color: #999999;
		}
	}

	.forgot {
		display: flex;
		justify-content: end;
		width: 100%;
		margin: 18px 0;
	}

	#otp_input {
		/* Firefox */
		-moz-appearance: textfield;

		/* Chrome, Safari, Edge, Opera */
		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
`;
